export default __webpack_public_path__ + "6b3ae59da1a586a6deedd6a73007b918.png";